import { BrowserRouter, Routes, Route } from 'react-router';
import { ThemeProvider } from '@edupra/shell';
import { SiteLayout } from './components/site-layout';
import { HomePage } from './pages/home';
import { PricingPage } from './pages/pricing';
import { FeaturesPage } from './pages/features';
import { ContactPage } from './pages/contact';
import { DownloadPage } from './pages/download';
import { NotFoundPage } from './pages/not-found';
import { BrandSheet } from './pages/brand';

export function App() {
  return (
    <ThemeProvider storageKey="edupra-landing-theme">
      <BrowserRouter>
        <Routes>
          <Route element={<SiteLayout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/features" element={<FeaturesPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/download" element={<DownloadPage />} />
            <Route path="/brand" element={<BrandSheet />} />
            <Route path="*" element={<NotFoundPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}
